import { render, staticRenderFns } from "./ModifyUserGroup.vue?vue&type=template&id=6238ea5a&scoped=true&"
import script from "./ModifyUserGroup.vue?vue&type=script&lang=ts&"
export * from "./ModifyUserGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyUserGroup.vue?vue&type=style&index=0&id=6238ea5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6238ea5a",
  null
  
)

export default component.exports